<template>
  <div class="input-group d-flex">
    <div class="flow-search">
      <input
        :value="search"
        @input="$emit('input', $event.target.value)"
        type="text"
        placeholder="Search by group name"
        class="form-control flow-search__input"
      />
      <i class="fa fa-search flow-search__icon" aria-hidden="true"></i>
    </div>
    <button @click.prevent="$emit('toggle-all')" class="btn btn-lg btn-primary ml-4">
      {{ everySelected ? 'Unselect all groups' : 'Select all groups' }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'flow-search',
  props: {
    search: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    everySelected: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/web/_variables.scss';
.flow-search {
  position: relative;
  width: 100%;
  margin: 0 auto;
  color: $dove-grey-color;
  &__input {
    height: 48px;
    background: $white-color;
    border: 1px solid $platinum-color;
    border-radius: 4px;
    padding: 0 16px 0 40px;
    color: currentColor;
    @media (min-width: $breakpoint-lg) {
      padding: 0 16px 0 57px;
      font-size: 14px;
    }
    &:focus {
      border: 2px solid $half-baked-color;
      outline: none;
    }
    &::placeholder {
      color: currentColor;
      font-size: 14px;
    }
  }
  &__icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 16px;
    font-size: 18px;
    z-index: 100;
    @media (min-width: $breakpoint-lg) {
      font-size: 25px;
    }
  }
}
</style>
